import React from "react";

const Button = ({ text, onClick, className }) => {
  return (
    <button
      className={`bg-[#fe8235] text-white text-xl font-semibold py-3 px-4 rounded-lg 
                transition duration-300 ease-in-out transform 
                hover:bg-[#e76d2a] hover:shadow-md 
                active:scale-90 active:bg-[#e76d2a] 
                ${className}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default Button;
